var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section", staticStyle: { width: "100%" } },
          [
            _c(
              "div",
              { staticStyle: { "padding-top": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.seachEventHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.recipientEventHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Acquisition")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.invalidEventHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Invalid")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.restoreEventHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Restore")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.userEventHandker()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Use")))]
                )
              ],
              1
            ),
            _c(
              "el-form",
              {
                staticStyle: { "padding-top": "10px" },
                attrs: {
                  "label-width": "60px",
                  "label-position": "left",
                  inline: true
                }
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_InvoiceNo") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              model: {
                                value: _vm.filter.txtInoviceNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "txtInoviceNo", $$v)
                                },
                                expression: "filter.txtInoviceNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_InvoiceType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                model: {
                                  value: _vm.filter.invoiceType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "invoiceType", $$v)
                                  },
                                  expression: "filter.invoiceType"
                                }
                              },
                              _vm._l(
                                _vm.InvoiceConstant.INVOICE_TYPES_HAS_ALL,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.language
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_InvoiceStatus")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                model: {
                                  value: _vm.filter.invoiceState,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "invoiceState", $$v)
                                  },
                                  expression: "filter.invoiceState"
                                }
                              },
                              _vm._l(
                                _vm.InvoiceConstant.INVOICE_STATUS_HAS_ALL,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.language
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Acquirer") }
                          },
                          [
                            _c("cargo-user-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "default-value":
                                  _vm.filter.autoRecipienter || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.filter.autoRecipienter = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AcquisitionTime")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "picker-options":
                                  _vm.recipientingDateMinPickerOptions,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.changeRecipientingDateMin },
                              model: {
                                value: _vm.filter.recipientingDateMin,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filter,
                                    "recipientingDateMin",
                                    $$v
                                  )
                                },
                                expression: "filter.recipientingDateMin"
                              }
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_To")) + " "
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "picker-options":
                                  _vm.recipientingDateMaxPickerOptions,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.changeRecipientingDateMax },
                              model: {
                                value: _vm.filter.recipientingDateMax,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filter,
                                    "recipientingDateMax",
                                    $$v
                                  )
                                },
                                expression: "filter.recipientingDateMax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_User") } },
                          [
                            _c("cargo-user-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "default-value": _vm.filter.autoUser || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.filter.autoUser = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_TimeOfUse") }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "picker-options": _vm.usingDateMinPickerOptions,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.changeUsingDateMin },
                              model: {
                                value: _vm.filter.usingDateMin,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "usingDateMin", $$v)
                                },
                                expression: "filter.usingDateMin"
                              }
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_To")) + " "
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "picker-options": _vm.usingDateMaxPickerOptions,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.changeUsingDateMax },
                              model: {
                                value: _vm.filter.usingDateMax,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "usingDateMax", $$v)
                                },
                                expression: "filter.usingDateMax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section grid-wrapper",
            staticStyle: { "min-height": "350px" }
          },
          [
            _c("cargo-ag-grid", {
              key: "1906064",
              staticStyle: { flex: "1" },
              attrs: {
                "config-module": "1906064",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.invoiceRecordsWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.invoiceRecordsWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_InvoiceAcquisition"),
                width: "350px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.invoiceRecordsWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "center" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Acquirer") } },
                        [
                          _c("cargo-user-select", {
                            ref: "userAuto",
                            attrs: {
                              "default-value":
                                _vm.invoiceRecordsWindow.userAuto || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.invoiceRecordsWindow.userAuto = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_AcquisitionTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "recipientingDate",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.invoiceRecordsWindow.recipientingDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.invoiceRecordsWindow,
                                  "recipientingDate",
                                  $$v
                                )
                              },
                              expression:
                                "invoiceRecordsWindow.recipientingDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.okEventRecords }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.invoiceRecordsWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.invoiceUserWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.invoiceUserWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_InvoiceUse"),
                width: "350px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.invoiceUserWindow, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "center" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_User") } },
                        [
                          _c("cargo-user-select", {
                            ref: "userAuto",
                            attrs: {
                              "default-value":
                                _vm.invoiceUserWindow.userAuto || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.invoiceUserWindow.userAuto = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TimeOfUse") }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "userDate",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.invoiceUserWindow.userDate,
                              callback: function($$v) {
                                _vm.$set(_vm.invoiceUserWindow, "userDate", $$v)
                              },
                              expression: "invoiceUserWindow.userDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.okEventUser }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.invoiceUserWindow.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }